module.exports = __webpack_public_path__ + "static/media/radio europa2@2x.e0b83d51.png";